export default __webpack_public_path__ + "static/media/Matthew.3f6acc0f.png";